import type { RouteObject } from "react-router-dom";

import { DryRunScreen } from "./DryRunScreen";

/** Discovered by 06b's `router.tsx`. `:migrationId` matches `stageRoute.pathForStage(id, "dry-run")`. */
export const routes: RouteObject[] = [
  { path: "/migrations/:migrationId/dry-run", element: <DryRunScreen /> },
];
